const dateWithoutTimezone = (value) => {
    return new Date(value.toISOString().slice(0, -1));
};

export default dateWithoutTimezone;